import { dom } from "@/utils/dom";

export function download(filename: string, href: string) {
  const a = document.createElement('a')
  a.download = filename
  a.href = href
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}

export function downloadJson(filename: string, data: any) {
  return downloadTextData(filename, 'text/json', JSON.stringify(data, null, 2))
}

export function downloadTextData(filename: string, contentType: string, data: string) {
  const href = `data:${contentType};charset=utf-8,${encodeURIComponent(data)}`
  return download(filename, href)
}

class FileDialog {
  readonly el: HTMLInputElement
  readonly form: HTMLFormElement

  private constructor() {
    this.el = document.createElement('input')
    this.el.type = 'file'
    this.form = document.createElement('form')
    this.form.style.display = 'none'
    this.form.appendChild(this.el)
    document.body.appendChild(this.form)
  }

  reject?: () => void
  off?: () => void

  open() {
    return new Promise<FileList | null>((resolve, reject) => {
      if (this.reject) {
        this.reject()
        this.off!()
      }
      this.reject = reject
      this.form.reset()
      this.off = dom.once(this.el, 'change', () => {
        this.reject = undefined
        resolve(this.el.files)
      })
      this.el.click()
    })
  }

  static instance = new FileDialog()
}

export function fileDialog() {
  return FileDialog.instance.open()
}

export function readFileAsText(file: File) {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader()
    reader.addEventListener('load', () => resolve(reader.result as string))
    reader.addEventListener('error', (event) => reject({ event, reader }))
    reader.readAsText(file)
  })
}

export function readFileAsBuffer(file: File) {
  return new Promise<ArrayBuffer>((resolve, reject) => {
    const reader = new FileReader()
    reader.addEventListener('load', () => resolve(reader.result as ArrayBuffer))
    reader.addEventListener('error', (event) => reject({ event, reader }))
    reader.readAsArrayBuffer(file)
  })
}
